import { i18n } from "@tellescope/i18n";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { Dispatch, SetStateAction } from "react";
import { createStore } from "@tellescope/store";

/** URL viewId used by `/contacts/views/:viewId` for the unfiltered all-contacts view. */
export const ALL_CONTACTS_VIEW_ID = "all";

const getDefaultTitle = () => i18n.t("Default View", { ns: "contacts" });

export const DEFAULT_CONTACTS_VIEW = {
  id: "default",
  businessId: "",
  updatedAt: new Date(0),
  creator: "",
  title: getDefaultTitle(),
  page: "Endusers",
  columns: [
    { field: "Name" },
    { field: "Email" },
    { field: "Phone" },
    { field: "CareTeam" },
    { field: "Tags" },
    { field: "DateOfBirth" },
    { field: "Actions" },
  ],
  createdAt: new Date(0),
} as const satisfies TellescopeModelFromName<"table_views">;

interface ContactsDefaultViewStore {
  defaultViewByUserId: Record<string, TellescopeModelFromName<"table_views">>;
  setUserDefaultView: (
    userId: string,
    newVal: Parameters<Dispatch<SetStateAction<TellescopeModelFromName<"table_views">>>>[0]
  ) => void;
  /** URL `:viewId` of the last `/contacts/views/:viewId` the user visited. */
  lastSelectedViewId: string;
  setLastSelectedViewId: (viewId: string) => void;
}

export const { useStore: useContactsDefaultViewStore, useShallowStore: useContactsDefaultViewShallowStore } =
  createStore<ContactsDefaultViewStore>(
    (set) => ({
      defaultViewByUserId: {},
      setUserDefaultView: (userId, newVal) =>
        set((state) => {
          const currentValue = state.defaultViewByUserId[userId] ?? DEFAULT_CONTACTS_VIEW;
          const resolvedVal = typeof newVal === "function" ? newVal(currentValue) : newVal;

          return {
            ...state,
            defaultViewByUserId: {
              ...state.defaultViewByUserId,
              [userId]: resolvedVal,
            },
          };
        }),
      lastSelectedViewId: ALL_CONTACTS_VIEW_ID,
      setLastSelectedViewId: (viewId) => set({ lastSelectedViewId: viewId }),
    }),
    {
      persist: "localStorage",
      name: "DEFAULT_CONTACTS_TABLE_VIEW",
    }
  );
